import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Check } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Panel, Empty, GoldButton, inputCls } from "@/components/common";

// Editable list of simple records (zone laser, sconti fedeltà)
const Row = ({ item, fields, onSave, onDelete, testPrefix }) => {
  const [f, setF] = useState(item);
  const dirty = fields.some((x) => String(f[x.key]) !== String(item[x.key]));
  return (
    <li className="flex flex-wrap items-center gap-3 py-3" data-testid={`${testPrefix}-row-${item.id}`}>
      {fields.map((x) => (
        <label key={x.key} className={`${x.className || "flex-1 min-w-[140px]"}`}>
          <span className="sm:hidden block text-[10px] uppercase tracking-[0.14em] text-[#9E958A] mb-1">{x.label}</span>
          <input type={x.type || "text"} className={inputCls} value={f[x.key]} placeholder={x.label}
            onChange={(e) => setF({ ...f, [x.key]: e.target.value })} data-testid={`${testPrefix}-${x.key}-${item.id}`} />
        </label>
      ))}
      <button disabled={!dirty} onClick={() => onSave(f)} className="text-[#2D6A4F] disabled:opacity-25" title="Salva" data-testid={`${testPrefix}-save-${item.id}`}><Check className="h-4 w-4" /></button>
      <button onClick={onDelete} className="text-[#6E675F] hover:text-red-700" title="Elimina" data-testid={`${testPrefix}-delete-${item.id}`}><Trash2 className="h-4 w-4" /></button>
    </li>
  );
};

export const InlineCatalog = ({ resource, fields, blank, testPrefix, emptyText, onChange }) => {
  const [items, setItems] = useState([]);
  const [nf, setNf] = useState(blank);
  const load = useCallback(() => api.get(`/${resource}`).then((r) => { setItems(r.data); onChange?.(r.data); }), [resource, onChange]);
  useEffect(() => { load(); }, [load]);

  const cast = (f) => Object.fromEntries(fields.map((x) => [x.key, x.type === "number" ? Number(f[x.key]) || 0 : f[x.key]]));
  const add = async () => {
    if (!String(nf.name).trim()) return toast.error("Il nome è obbligatorio");
    try { await api.post(`/${resource}`, cast(nf)); setNf(blank); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const save = async (f) => { try { await api.put(`/${resource}/${f.id}`, cast(f)); toast.success("Salvato"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const del = async (id) => { if (window.confirm("Eliminare?")) { await api.delete(`/${resource}/${id}`); load(); } };

  return (
    <Panel className="p-5 sm:p-6">
      <div className="mb-2 hidden sm:flex gap-3 text-xs uppercase tracking-[0.14em] text-[#6E675F]">
        {fields.map((x) => <span key={x.key} className={x.className || "flex-1 min-w-[140px]"}>{x.label}</span>)}<span className="w-12" />
      </div>
      {items.length === 0 && <Empty testId={`${testPrefix}-empty`}>{emptyText}</Empty>}
      <ul className="divide-y divide-[#E8E1D7]">
        {items.map((it) => <Row key={`${it.id}-${JSON.stringify(it)}`} item={it} fields={fields} onSave={save} onDelete={() => del(it.id)} testPrefix={testPrefix} />)}
      </ul>
      <div className="mt-4 flex flex-wrap items-center gap-3 border-t border-[#E8E1D7] pt-4">
        {fields.map((x) => (
          <input key={x.key} type={x.type || "text"} className={`${inputCls} ${x.className || "flex-1 min-w-[140px]"}`} value={nf[x.key]} placeholder={x.label}
            onChange={(e) => setNf({ ...nf, [x.key]: e.target.value })} data-testid={`${testPrefix}-new-${x.key}`} />
        ))}
        <GoldButton onClick={add} className="px-4" data-testid={`${testPrefix}-add-button`}><Plus className="h-4 w-4" /> Aggiungi</GoldButton>
      </div>
    </Panel>
  );
};
